import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AlertMessages } from '../../data/alert-messages.enum';

@Component({
  selector: 'app-info-alert-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './info-alert-card.component.html',
  styleUrls: ['./info-alert-card.component.scss'],
})
export class InfoAlertCardComponent {
  readonly messageType = input.required<AlertMessages>();
  readonly type = input<'info' | 'warning' | 'error' | 'success'>('info');
  readonly showIcon = input(true);
}
